<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="secure"/>
        <h2 id="pageTitle">{{ 'bss.passwordChangeSuccess.title' | translate }}</h2>
        <hr>
        
        <p>{{ 'bss.passwordChangeSuccess.subTitle' | translate }}</p>
        <button tabindex="106" (click)="onSubmit()" class="ontario-button ontario-button--primary" title="{{ 'bss.passwordChangeSuccess.viewProfile.title' | translate }}">
            {{ 'bss.passwordChangeSuccess.viewProfile' | translate }}
        </button>
    </div>
</div>
